export const onCellKeyDownEvent = ({ params, onCellKeyDown }) => {
  if (onCellKeyDown) onCellKeyDown(params);
};